(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3172],{

/***/ 72035:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs",
      function () {
        return __webpack_require__(53622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DocsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./components/docs/layout/sidenav.tsx
var sidenav = __webpack_require__(32596);
// EXTERNAL MODULE: ./components/docs/layout/header.tsx + 6 modules
var header = __webpack_require__(6903);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(63519);
// EXTERNAL MODULE: ./components/docs/page/page-container.tsx
var page_container = __webpack_require__(29856);
// EXTERNAL MODULE: ./components/docs/page/home/cta-card.tsx
var cta_card = __webpack_require__(23649);
// EXTERNAL MODULE: ./components/docs/page/home/section-heading.tsx
var section_heading = __webpack_require__(66275);
// EXTERNAL MODULE: ./components/docs/page/home/content.ts
var content = __webpack_require__(51297);
// EXTERNAL MODULE: ./components/docs/page/home/support.tsx
var support = __webpack_require__(19630);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
// EXTERNAL MODULE: ./node_modules/@clerk/nextjs/dist/index.js
var dist = __webpack_require__(16855);
;// CONCATENATED MODULE: ./components/docs/page/home/home.tsx













function DocsHome() {
    const { colorMode  } = (0,dist_index_esm/* useColorMode */.If)();
    const isLightMode = colorMode === "light";
    const { client  } = (0,dist.useClerk)();
    (0,react_production_min.useEffect)(()=>{
        if (client) pages.analytics.track("Docs_Page_Home Viewed", {
            surface: "Docs",
            location: "Page",
            instanceId: client === null || client === void 0 ? void 0 : client.id
        });
    }, [
        client
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    pos: "relative",
                    py: {
                        base: 12,
                        lg: 16,
                        xl: 24
                    },
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                    as: "h1",
                                    fontSize: "32px",
                                    fontWeight: "medium",
                                    mb: 2,
                                    color: "var(--primaryTextColor)",
                                    children: [
                                        "Welcome to",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Clerk Docs"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    color: "var(--secondaryTextColor)",
                                    children: [
                                        "Find all the guides and resources",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "you need to develop with Clerk."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            pos: "absolute",
                            display: {
                                base: "none",
                                lg: "block"
                            },
                            bottom: "0",
                            right: 0,
                            sx: {
                                // Chakra's `lg` breakpoint
                                "@media (min-width: 992px)": {
                                    h: "170px",
                                    w: "430px"
                                },
                                "@media (min-width: 1080px)": {
                                    h: "200px",
                                    w: "490px"
                                },
                                // Chakra's `xl` breakpoint
                                "@media (min-width: 1280px)": {
                                    h: "280px",
                                    w: "655px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: isLightMode ? "/images/docs-hero-light.svg" : "/images/docs-hero-dark.svg",
                                layout: "fill",
                                alt: "Clerk components"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                maxW: "container.lg",
                mx: "auto",
                px: {
                    base: 6,
                    lg: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                        columns: {
                            base: 1,
                            md: 2
                        },
                        gap: 6,
                        w: "full",
                        children: content/* generalSuggestions.map */.vi.map((param)=>/*#__PURE__*/ {
                            let { title , description , url , icon  } = param;
                            return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                title: title,
                                description: description,
                                url: url,
                                icon: icon,
                                ctaText: "Get started",
                                size: "lg"
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Explore by",
                                boldText: "Frontend Framework"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2,
                                    xl: 3
                                },
                                gap: 6,
                                w: "full",
                                children: (0,content/* frontendSuggestions */.jz)(isLightMode).map((param)=>/*#__PURE__*/ {
                                    let { title , description , url , logo , logoHeight , logoWidth  } = param;
                                    return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                        title: title,
                                        description: description,
                                        url: url,
                                        logo: logo,
                                        logoHeight: logoHeight,
                                        logoWidth: logoWidth,
                                        ctaText: "Learn more"
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Explore by",
                                boldText: "Backend Framework"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2,
                                    xl: 3
                                },
                                gap: 6,
                                w: "full",
                                children: (0,content/* backendSuggestions */.rI)(isLightMode).map((param)=>/*#__PURE__*/ {
                                    let { title , description , url , logo , logoWidth , icon  } = param;
                                    return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                        title: title,
                                        description: description,
                                        url: url,
                                        logo: logo,
                                        logoWidth: logoWidth,
                                        icon: icon,
                                        ctaText: "Learn more"
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Explore by",
                                boldText: "Feature"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2
                                },
                                gap: 6,
                                w: "full",
                                children: content/* featureSuggestions.map */.wZ.map((param)=>/*#__PURE__*/ {
                                    let { title , description , url , icon  } = param;
                                    return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                        title: title,
                                        description: description,
                                        url: url,
                                        icon: icon,
                                        ctaText: "Learn more"
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        py: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                boldText: "Learn the concepts",
                                size: "lg"
                            }),
                            content/* conceptsSuggestions.map */.s7.map((param)=>/*#__PURE__*/ {
                                let { title , description , url  } = param;
                                return (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    direction: {
                                        base: "column",
                                        md: "row"
                                    },
                                    py: 6,
                                    borderBottom: "1px solid",
                                    borderColor: "var(--borderColor)",
                                    gap: {
                                        base: 1,
                                        md: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            as: "h3",
                                            size: "3xs",
                                            lineHeight: "unset",
                                            flex: "1",
                                            color: "var(--primaryTextColor)",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                            spacing: 4,
                                            flex: "1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    textStyle: "sm-normal",
                                                    color: "var(--secondaryTextColor)",
                                                    children: description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    legacyBehavior: true,
                                                    href: url,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                        as: "a",
                                                        color: "var(--secondaryTextColor)",
                                                        textStyle: "xs-medium",
                                                        role: "group",
                                                        _hover: {
                                                            color: "var(--secondaryBlue)"
                                                        },
                                                        children: [
                                                            "Learn more",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                                as: ArrowRightIcon/* default */.Z,
                                                                ml: 1,
                                                                pos: "relative",
                                                                top: "-1px",
                                                                transition: "margin-left .2s",
                                                                _groupHover: {
                                                                    ml: 2
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, title);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/docs/layout/footer.tsx + 1 modules
var footer = __webpack_require__(36651);
// EXTERNAL MODULE: ./hooks/use-route-scroll.ts
var use_route_scroll = __webpack_require__(8253);
;// CONCATENATED MODULE: ./pages/docs/index.tsx






var __N_SSG = true;
function DocsPage(param) {
    let { data , navigation  } = param;
    const router = (0,next_router.useRouter)();
    (0,use_route_scroll/* useRouteScroll */.t)();
    if (!data || !router.isFallback && !data.slug) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
            statusCode: 404
        });
    }
    return router.isFallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Loading..."
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        minH: "100vh",
        bg: "var(--bodyBg)",
        color: "var(--primaryTextColor)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sidenav/* DocsSidenav */.x, {
                navigation: navigation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* DocsHeader */.U, {
                navigation: navigation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsHome, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* DocsFooter */.E, {})
        ]
    });
}


/***/ }),

/***/ 77082:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function LinkIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (LinkIcon);

/***/ }),

/***/ 75426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CheckCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CheckCircleIcon);

/***/ }),

/***/ 45001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationCircleIcon);

/***/ }),

/***/ 33772:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationIcon);

/***/ }),

/***/ 71738:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeIcon);

/***/ }),

/***/ 77481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeOffIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeOffIcon);

/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function InformationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (InformationCircleIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2868,659,617,174,9774,2888,179], function() { return __webpack_exec__(72035); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);